import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import KitchenView from '../components/Dashboard/KitchenView';
import { enableAudio } from '../utils/speech';
import { useCustomDialog } from '../context/DialogContext';
import usePWAInstall from '../hooks/usePWAInstall';

const KitchenDashboard = () => {
    const { alert: customAlert } = useCustomDialog();
    const [token, setToken] = useState(null);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    usePWAInstall();

    useEffect(() => {
        const storedToken = localStorage.getItem('staff_token');
        const storedUser = localStorage.getItem('staff_user');
        if (storedToken && storedUser) {
            setToken(storedToken);
            setUser(JSON.parse(storedUser));
        } else {
            navigate('/staff-login');
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('staff_token');
        localStorage.removeItem('staff_user');
        navigate('/staff-login');
    };

    const [audioUnlocked, setAudioUnlocked] = useState(false);

    const unlockAudio = () => {
        enableAudio();
        setAudioUnlocked(true);
    };

    const handleRequestWaiter = async () => {
        try {
            const res = await fetch('https://menu.searchisend.in/apimenu/v2/v2_alerts.php?action=create', {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ target_role: 'waiter', message_text: 'Alert: Waiter required in the kitchen.' })
            });
            const json = await res.json();
            if (json.success) {
                customAlert("Waiter requested successfully!", "Success", "success");
            }
        } catch(err) {
            console.error(err);
        }
    };

    if (!token) return null;

    return (
        <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: "'Outfit', sans-serif" }}>
            {/* Simple Staff Header */}
            <header style={{ background: '#fff', padding: '15px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', sticky: 'top', top: 0, zIndex: 100 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: '40px', height: '40px', background: 'var(--primary-orange)', color: '#fff', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="fas fa-fire-burner" />
                    </div>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '800' }}>Kitchen Board</h2>
                        <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748b' }}>Staff: {user.name} ({user.role})</p>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button 
                        onClick={handleRequestWaiter}
                        style={{ background: 'var(--primary-orange)', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '50px', fontWeight: '700', fontSize: '0.85rem', cursor: 'pointer' }}
                    >
                        <i className="fas fa-bell-concierge" style={{ marginRight: '5px' }} /> Request Waiter
                    </button>
                    <button 
                        onClick={handleLogout}
                        style={{ background: '#fee2e2', color: '#ef4444', border: 'none', padding: '8px 16px', borderRadius: '50px', fontWeight: '700', fontSize: '0.85rem', cursor: 'pointer' }}
                    >
                        <i className="fas fa-sign-out-alt" style={{ marginRight: '5px' }} /> Logout
                    </button>
                </div>
            </header>

            {!audioUnlocked && (
                <div style={{ background: '#1e293b', color: '#fff', padding: '12px', textAlign: 'center', cursor: 'pointer' }} onClick={unlockAudio}>
                    <i className="fas fa-volume-up" style={{ color: 'var(--primary-orange)', marginRight: '8px' }}></i>
                    <strong>Click anywhere on this banner to enable Audio Alerts</strong>
                </div>
            )}

            <main style={{ maxWidth: '1400px', margin: '0 auto' }}>
                <KitchenView token={token} />
            </main>
        </div>
    );
};

export default KitchenDashboard;

